import React, { useState, useEffect } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import api from '../../services/api';

export default function TaskTemplates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/tasks/templates');
        if (res?.data) setTemplates(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const columns = [
    { key: 'name', label: 'Шаблон', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
    { key: 'type', label: 'Тип', render: v => <Badge variant={v === 'osg' ? 'osg' : 'display'}>{v === 'osg' ? 'ОСГ' : 'Выкладка'}</Badge> },
    { key: 'frequency', label: 'Частота', render: v => v === 'daily' ? 'Ежедневно' : v === 'weekly' ? 'Еженедельно' : v || '\u2014' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Шаблоны задач</h1>
      <Card padding="0">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={templates} emptyText="Шаблоны не созданы" />
        )}
      </Card>
    </div>
  );
}
